<template>
    <div class="coupon-page">
        <mt-header fixed title="我的优惠券" style="background:#ffffff;color:#262626;">
            <mt-button icon="back" slot="left" @click="goBack"></mt-button>
        </mt-header>
        <div class="no-data">
            <img src="../assets/images/coupon_data_none@3x.png">
            <p>您暂时没有优惠券</p>
            <div class="goBack" @click="goBack">返回</div>
        </div>
    </div>
</template>

<script>
import Footer_ from './Footer.vue';
import ServiceSteps from './modules/ServiceSteps';
import CopyrightFooter from './modules/CopyrightFooter'

export default {
  metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
  },
  data(){
    return{
      code:"",
      goodsList:[],//商品列表
      H5_URL:window.config.H5_URL,
      redirect:true,
      m_guoshixiong_aboutus: {
        'channel': "m.gsx.aboutus",
        'channel_name': "关于我们页面-立即下载",
      },
      dl_href:window.config.gsx_dl_base+'m.gsx.aboutus',
      loginStatus: false
    }
  },
  mounted(){
        
  },
  created(){
  },
  methods:{
      goBack(){
        history.go(-1)
      }
  },
  components:{
    Footer_,
    ServiceSteps,
    CopyrightFooter
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Coupon.vue